import React, { forwardRef } from 'react';
import styles from './WorkspaceView.module.scss';
import { SFDivider, SFScrollableProps, SFScrollableRefHandler } from 'sfui';
import { IntersectionObserverHost } from '../../IntersectionObserver';

export interface WorkspaceViewProps extends SFScrollableProps {
  header?: React.ReactNode;
  sticky?: React.ReactNode;
  children: React.ReactNode;
}

export const WorkspaceView = forwardRef<
  SFScrollableRefHandler,
  WorkspaceViewProps
>(
  (
    { header, sticky, ...props }: WorkspaceViewProps,
    ref
  ): React.ReactElement<WorkspaceViewProps> => {
    return (
      <IntersectionObserverHost
        {...props}
        ref={ref}
        containerClassName={`${styles.workspaceView} ${props.className || ''}`}
      >
        {header && <div className={styles.header}>{header}</div>}

        {sticky && (
          <div className={styles.sticky}>
            {sticky}
            <SFDivider />
          </div>
        )}

        {props.children}
      </IntersectionObserverHost>
    );
  }
);
